import React, {Component} from 'react';
import {clearUserStats, getUserStats} from '../services/UserStatsService';
import {LearnBox} from "./LearnBox";
import {LearnPage} from "./LearnPage";
import {LearnSection} from "./LearnSection";
import {Login} from "../sandbox/Login";

export class Profile extends Component {
    static displayName = Profile.name;

    constructor(props) {
        super(props);
        this.state = {
            userStats: getUserStats()
        };
        this.handleClearUserProfile = this.handleClearUserProfile.bind(this);
    }

    handleClearUserProfile(event) {
        clearUserStats();
        this.setState({userStats: getUserStats()});
    }

    render() {
        return (
            <LearnPage title="Bruger-profil">
                <LearnSection>
                    <LearnBox title="Log ind">
                        <Login />
                    </LearnBox>
                    <LearnBox title="Din bruger-profil">
                        <p>Din bruger-profil består kun af data der gemmes direkte i din browser.</p>
                        <p>Der er følgende data gemt i din browser:</p>
                        <p>{JSON.stringify(this.state.userStats)}</p>
                    </LearnBox>
                    <LearnBox title="Slet bruger-profil">
                        <p>Sletning af din bruger-profil består i at slette det data der er gemt i din
                            browser!</p>
                        <p>Du kan nulstille din bruger-profil her:</p>
                        <input type="button" className="btn btn-primary" value="Slet bruger-profil"
                               onClick={this.handleClearUserProfile}/>
                    </LearnBox>
                </LearnSection>
            </LearnPage>
        );
    }
}
